module.exports = __webpack_public_path__ + "img/5手机.7ebc82d1.png";